import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AppAuthProvider } from '@/contexts/AuthContext';
import { AuthTokenBridge } from '@/contexts/AuthTokenBridge';
import { FilterProvider } from '@/contexts/FilterContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { UiProvider } from '@/contexts/UiContext';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { router } from '@/routes/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AppAuthProvider>
            <AuthTokenBridge>
              <FilterProvider>
                <UiProvider>
                  <RouterProvider router={router} />
                </UiProvider>
              </FilterProvider>
            </AuthTokenBridge>
          </AppAuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
